import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const RelatedCaseStudies = ({ service }) => {
  return (
    <div className="bg-white rounded-xl shadow-soft border border-border p-8">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 rounded-full gradient-primary flex items-center justify-center">
          <Icon name="FileText" size={20} color="white" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">
            Related Case Studies
          </h3>
          <p className="text-sm text-muted-foreground">
            See how we've helped similar clients
          </p>
        </div>
      </div>

      <div className="space-y-6">
        {service.caseStudies.map((study, index) => (
          <div key={index} className="border border-border rounded-lg p-4 hover:shadow-soft transition-smooth">
            <div className="flex space-x-4">
              <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0">
                <Image 
                  src={study.thumbnail}
                  alt={study.title}
                  className="w-full h-full object-cover"
                />
              </div>
              
              <div className="flex-1 min-w-0">
                <h4 className="font-semibold text-foreground mb-1 line-clamp-2">
                  {study.title}
                </h4>
                <p className="text-sm text-muted-foreground mb-2 line-clamp-2">
                  {study.description}
                </p>
                
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4 text-xs text-muted-foreground">
                    <span className="flex items-center space-x-1">
                      <Icon name="Building2" size={12} />
                      <span>{study.industry}</span>
                    </span>
                    <span className="flex items-center space-x-1">
                      <Icon name="TrendingUp" size={12} />
                      <span>{study.improvement}</span>
                    </span>
                  </div>
                  
                  <Link 
                    to="/services-overview"
                    className="text-primary hover:text-secondary text-sm font-medium transition-smooth"
                  >
                    Read More →
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 pt-6 border-t border-border">
        <Link 
          to="/services-overview"
          className="flex items-center justify-center space-x-2 text-primary hover:text-secondary font-medium transition-smooth"
        >
          <span>View All Case Studies</span>
          <Icon name="ArrowRight" size={16} />
        </Link>
      </div>
    </div>
  );
};

export default RelatedCaseStudies;